<div class="mb-3">
  <ng-template [ngTemplateOutlet]="saveBtnTmpl"></ng-template>
</div>

<div class="container-box p-3">
  <app-loading-section *ngIf="isLoading && !licenses"></app-loading-section>
  <app-bdc-licenses-form #licenseForm [licenses]="licenses" *ngIf="isLicenseRequired"></app-bdc-licenses-form>
  <app-empty-table *ngIf="!isLicenseRequired">
    <img class="empty-image" src="assets/images/empty_icons/bdc-license.svg" />
    <h5 class="empty-header" i18n>No License Required</h5>
    <p i18n>This property doesn’t require a license based on current regulations. You’re all set—no action needed.</p>
  </app-empty-table>
</div>

<div class="mt-3">
  <ng-template [ngTemplateOutlet]="saveBtnTmpl"></ng-template>
</div>

<ng-template #saveBtnTmpl>
  <div class="d-flex align-items-center justify-content-end">
    <button class="btn btn-secondary-info" [disabled]="isLoading || !isLicenseRequired" (click)="onSave()">
      <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
      <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
</ng-template>
